import { render, staticRenderFns } from "./OrderEmailDetail.vue?vue&type=template&id=1a99dd1a"
import script from "./OrderEmailDetail.vue?vue&type=script&lang=js"
export * from "./OrderEmailDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports